export default __webpack_public_path__ + "static/media/DavidImage.ead612ed.png";